import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenAwalRanapPerinatal";

interface Data {
  id: number;
  register_id: number;
  pasien_rm: string;
  unit_id: string;
  content: any;
  examined_at: string;
  perawat_user_id: number;
  dpjp_user_id: number | null;
  dpjp_verified_at: string | null;
  ppja_user_id: number | null;
  ppja_verified_at: string | null;
  creator_user_id: number | null;
  perawat?: any;
  dpjp?: any;
  ppja?: any;
  unit_pelayanan?: any;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-awal-ranap-perinatal"
})
class AsesmenAwalRanapPerinatalStore extends VuexModule {
  loading = false;
  list: Data[] = [];
  asesmen: Data | null = null;
  isAnyUnsavedChange = false;

  @Mutation
  SET_LIST(val) {
    this.list = val;
  }

  @Mutation
  SET_RECORD(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.asesmen = null;
    this.list = [];
    this.isAnyUnsavedChange = false;
    this.loading = false;
  }

  @Mutation
  SET_IS_ANY_UNSAVED_CHANGE(val) {
    this.isAnyUnsavedChange = val;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });
    const data = response.data?.data || [];
    this.SET_LIST(data);
    this.SET_RECORD(data.length > 0 ? data[0] : null);
  }

  @Action({ rawError: true })
  async find(id): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.find(id).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_RECORD(response.data?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }

  @Action({ rawError: true })
  setIsAnyUnsavedChange(val): void {
    this.SET_IS_ANY_UNSAVED_CHANGE(val);
  }
}

export default getModule(AsesmenAwalRanapPerinatalStore);
